module.exports = __webpack_public_path__ + "img/montevideo.2eb67b91.jpg";